<template lang="pug">
.container.expried-container.d-flex.align-items-center.flex-column
  .expried-body.m-auto.align-items-center.d-flex.flex-column.justify-content-center
    h1.typo-heading32.typo-semi-150.text-light-high.text-center {{ $t(message.title) }}
    p.typo-paragraph14.typo-regular-150.text-light-low.text-center {{ $t(message.content) }}
    img(class="thumbnail mt-3" :src="publicPath + require('@/modules/Static/assets/notfound.png')" alt="")
  Disclaimer(v-if="disclaimer")
</template>

<script>
import { Disclaimer } from "../components";
export default {
  name: "LibraryShare",
  components: {
    Disclaimer
  },
  data() {
    return {
      error: "",
      disclaimer: true
    }
  },
  computed: {
    message() {
      switch (this.error) {
        case "link_unavailable": {
          return {
            title: "staticSite.link_unavailable.title",
            content: "staticSite.link_unavailable.desc"
          }
        }
        case "link_expired": {
          return {
            title: "staticSite.link_expired.title",
            content: "staticSite.link_expired.desc"
          }
        }
        default: {
          return {
            title: "staticSite.expired_default.title",
            content: "staticSite.expired_default.desc"
          }
        }
      }
    }
  },
  created() {
    this.initCheck();
  },
  methods: {
    initCheck() {
      this.error = this.$route.params.type;
      const meta = this.$route.meta;
      if (meta && meta.error) {
        this.error = meta.error;
      }

      if (meta && meta.disclaimer != undefined) {
        this.disclaimer = meta.disclaimer;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.expried-container {
  height: calc(100vh - 65px);
  .expried-body {
    min-width: 600px;
    // min-height: 378px;
    max-width: 600px;
    // max-height: 378px;
    
  }
}

</style>
